import React from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'
import UtmUtils from '../../utils/utmUtils'
import { Close } from '@material-ui/icons'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { TopNavBarButton } from '../GJKit/Buttons/TopNavBarButton'
import { useDispatch, useSelector } from 'react-redux'
import { CloseCallDialog } from '../dialogs/CloseCallDialog'
import { selectOnCloseMessageCall, showOnCloseMessageCall } from '../../reducers/uiSlice'
import { usePIP } from '../../hooks/usePIP'
import { useUtm } from '@gojiraf/useutm'

const CloseCall = ({ iframe = false }) => {
  const { postHogTrackEvent } = usePostHogAnalytics()
  const dispatch = useDispatch()
  const closeCallMessageIsVisible = useSelector(selectOnCloseMessageCall)
  const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { isAppView } = useUtm(utm_medium)
  const { handleLeavePictureInPicture, isEnabled } = usePIP()

  const handleOnCloseCall = () => {
    postHogTrackEvent('event-click-close')
    if (isEnabled) handleLeavePictureInPicture()
    if (iframe) {
      window.parent.postMessage({ type: 'gojiraf-close' }, '*')
      return
    }

    dispatch(showOnCloseMessageCall())
  }

  return (
    <div>
      <TopNavBarButton
        style={{ opacity: isAppView ? '0' : '1.0' }}
        disabled={isAppView}
        id="event-click-close"
        data-test="close-call"
        onClick={handleOnCloseCall}
      >
        <Close />
      </TopNavBarButton>
      {closeCallMessageIsVisible && <CloseCallDialog />}
    </div>
  )
}

CloseCall.propTypes = {
  iframe: PropTypes.bool,
}

export { CloseCall }
